<template>
    <div class="box">
      <div class="top typeArea">
          <div class="top-left">
              <div>新化学物质登记试验在新化学物质环境风险管理中有着极其重要的作用，聚焦对环境和健康可能造成较大风险的新化学物质，保护生态环境，保障公众健康。贵州健安德是国内首批从事新化学物质登记试验单位，拥有非常丰富的经验。试验资质范围覆盖物理化学性质、生态毒理、健康毒理三大领域，已累计为苹果、拜耳等全球200多家企业提供服务。</div>
              <div @click="$router.push('/aboutUs/contactUs')">
                  <img src="@/assets/images/image57.png" alt="">
                  <span>联系我们</span>
              </div>
          </div>
          <div class="top-right">
              <defaultImg class="banner" :src="require('@/assets/images/image60.png')"></defaultImg>
          </div>
      </div>
      <div class="bottom">
            <!-- <cusTable :tableData="tableData"></cusTable> -->
            <div class="tableBox typeArea"> 
                <cusTable :tableData="tableData1" class="tableItem" rowHeight="44.65px"></cusTable>
                <cusTable :tableData="tableData2" class="tableItem" rowHeight="36px"></cusTable>
            </div>
            <div class="historyBox">
                <div class="historyBox-title">新化学物质登记试验单位资质历程</div>
                <historyCarousel :historyList="historyList"></historyCarousel>
            </div>
            <!-- <el-tabs class="tabs" v-model="activeName" @tab-click="{}">
                <el-tab-pane label="物理化学性质测试项目" name="first">
                    <tabContent class="mg-top40" :dataList="dataList1"></tabContent>
                </el-tab-pane>
                <el-tab-pane label="生态毒理学测试项目" name="second">
                    <tabContent class="mg-top40" :dataList="dataList2"></tabContent>
                </el-tab-pane>
                <el-tab-pane label="健康毒理学测试项目" name="third">
                    <div class="switch">
                        <div class="switch-active">急性毒性</div>
                        <div class="switch-default">致突变性</div>
                        <div class="switch-default">重复染毒毒性</div>
                        <div class="switch-default">生殖/发育毒性</div>
                    </div>
                    <tabContent :dataList="dataList3"></tabContent>
                </el-tab-pane>
            </el-tabs> -->
      </div>
    </div>
  </template>
  
  <script>
  import tabContent from '@/views/ourService/components/tabContent'
  import historyCarousel from '../../components/historyCarousel/historyCarousel.vue';
  export default {
    name: 'chemicalRegister',
    components:{tabContent,historyCarousel},
    data () {
      return {
            activeName: 'first',
            dataList1:[{
                src: require('@/assets/images/image58.png'),
                title: "产品化学试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "产品化学试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "产品化学试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "产品化学试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "产品化学试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "产品化学试验项目"
            }],
            dataList2:[{
                src: require('@/assets/images/image58.png'),
                title: "健康毒理试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "健康毒理试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "健康毒理试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "健康毒理试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "健康毒理试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "健康毒理试验项目"
            }],
            dataList3:[{
                src: require('@/assets/images/image58.png'),
                title: "环境影响试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "环境影响试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "环境影响试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "环境影响试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "环境影响试验项目"
            },{
                src: require('@/assets/images/image58.png'),
                title: "环境影响试验项目"
            }],
            tableData: [
                {
                    field: '物理化学性质试验项目',
                    project: '红外',
                    period: '1',
                    secondField: '图谱'
                },
                {
                    field: '物理化学性质试验项目',
                    project: '紫外',
                    period: '1',
                    secondField: '图谱'
                },
                {
                    field: '物理化学性质试验项目',
                    project: '质谱',
                    period: '1',
                    secondField: '图谱'
                },
                {
                    field: '物理化学性质试验项目',
                    project: '核磁',
                    period: '1',
                    secondField: '图谱'
                },
                {
                    field: '物理化学性质试验项目',
                    project: '熔点',
                    period: '1',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '沸点',
                    period: '1',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '蒸气压',
                    period: '2',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '水溶解度',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '分配系数(正辛醇/水)',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '液体和固体的密度',
                    period: '1',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '与pH值有关的水解作用',
                    period: '4',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '在水中的离解常数',
                    period: '2',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '水溶液的表面张力',
                    period: '1',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: 'pH值和酸碱度',
                    period: '1',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '粒径',
                    period: '1',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '冰点',
                    period: '2',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '比旋光度',
                    period: '1',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '亨利常数',
                    period: '1',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '环境中的检出方法及描述',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '聚合物在水中和有机溶剂中的溶解性',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '物理化学性质试验项目',
                    project: '聚合物在酸碱条件下的稳定性',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '吸附/解吸附性',
                    period: '6',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '藻类生长抑制毒性',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '溞类急性毒性',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '鱼类急性毒性',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '蚯蚓急性毒性',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '活性污泥呼吸抑制毒性',
                    period: '3',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '大型溞繁殖',
                    period: '5',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '鱼类幼体生长',
                    period: '6',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '种子发芽和根伸长的毒性',
                    period: '4',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '快速生物降解性',
                    period: '4',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '固有生物降解性',
                    period: '4',
                    secondField: ''
                },
                {
                    field: '生态毒理学试验项目',
                    project: '生物累积性',
                    period: '6',
                    secondField: ''
                },
                {
                    field: '健康毒理学试验项目',
                    project: '急性经口毒性',
                    period: '3',
                    secondField: '急性毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '急性经皮毒性',
                    period: '3',
                    secondField: '急性毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '急性吸入毒性',
                    period: '3',
                    secondField: '急性毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '皮肤腐蚀/刺激',
                    period: '3',
                    secondField: '急性毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '眼刺激',
                    period: '3',
                    secondField: '急性毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '皮肤致敏',
                    period: '3',
                    secondField: '急性毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '细菌回复突变',
                    period: '3',
                    secondField: '致突变性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '体外哺乳动物细胞染色体畸变',
                    period: '3',
                    secondField: '致突变性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '哺乳动物红细胞微核',
                    period: '3',
                    secondField: '致突变性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '哺乳动物骨髓染色体畸变',
                    period: '3',
                    secondField: '致突变性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '体外哺乳动物细胞基因突变',
                    period: '3',
                    secondField: '致突变性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '彗星试验',
                    period: '3',
                    secondField: '致突变性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '重复染毒28天经口毒性',
                    period: '4',
                    secondField: '重复染毒毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '反复经皮毒性（21/28天）',
                    period: '5',
                    secondField: '重复染毒毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '亚急性吸入毒性（28天）',
                    period: '4',
                    secondField: '重复染毒毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '亚慢性（90天）经口毒性',
                    period: '6',
                    secondField: '重复染毒毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '亚慢性（90天）经皮毒性',
                    period: '6',
                    secondField: '重复染毒毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '亚慢性（90天）吸入毒性',
                    period: '6',
                    secondField: '重复染毒毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '孕期发育毒性（致畸）',
                    period: '6',
                    secondField: '生殖/发育毒性'
                },
                {
                    field: '健康毒理学试验项目',
                    project: '两代繁殖毒性',
                    period: '18',
                    secondField: '生殖/发育毒性'
                },
            ],
            historyList:[
                {
                    date: '2010.11',
                    title:['化学物质测试机构'],
                    subtitle:[],
                    certification:{
                        name: '环境保护部',
                        src: [require('@/assets/images/chemicalHistory/2010.11-1.jpg'),require('@/assets/images/chemicalHistory/2010.11-2.jpg')] 
                    }
                },
                {
                    date: '2015.02',
                    title:['CNAS GLP','《良好实验室规范符合性证书》'],
                    subtitle:[],
                    certification:{
                        name: '国家认可委',
                        src: [require('@/assets/images/chemicalHistory/2015.02-CNAS GLP.jpg')]
                    }
                },
                {
                    date: '2015.02',
                    title:['化学品测试合格实验室'],
                    subtitle:[],
                    certification:{
                        name: '环境保护部',
                        src: [require('@/assets/images/chemicalHistory/2015.02.jpg')]
                    }
                },
                {
                    date: '2018.03',
                    title:['《检验检测机构资质认定证书》'],
                    subtitle:[],
                    certification:{
                        name: 'CMA',
                        src: [require('@/assets/images/chemicalHistory/2018.03.jpg')]
                    }
                },
                {
                    date: '2018.06',
                    title:['CNAS GLP','《良好实验室规范符合性证书》'],
                    subtitle:['（证书更新）'],
                    certification:{
                        name: '国家认可委',
                        src: [require('@/assets/images/chemicalHistory/2018.06.jpg')]
                    }
                },
                {
                    date: '2019.04',
                    title:['CNAS GLP','《良好实验室规范符合性证书》'],
                    subtitle:['（证书更新）'],
                    certification:{
                        name: '国家认可委',
                        src: [require('@/assets/images/chemicalHistory/2019.04.jpg')]
                    }
                },
                {
                    date: '2019.05',
                    title:['化学品测试机构备案'],
                    subtitle:[],
                    certification:{
                        name: '生态环境部',
                        src: [require('@/assets/images/chemicalHistory/2019.05.jpg')]
                    }
                },
                {
                    date: '2019.07',
                    title:['《检验检测机构资质认定证书》'],
                    subtitle:['—化学品、农药、化妆品、消毒产品、食品'],
                    certification:{
                        name: 'CMA',
                        src: [require('@/assets/images/chemicalHistory/2019.07.jpg')]
                    }
                },
                {
                    date: '2021.06',
                    title:['CNAS GLP','《良好实验室规范符合性证书》'],
                    subtitle:['（证书更新）'],
                    certification:{
                        name: '环境保护部',
                        src: [require('@/assets/images/chemicalHistory/2021.06-CNAS-GLP.jpg')]
                    }
                },
                {
                    date: '2022.06',
                    title:['《检验检测机构资质认定证书》'],
                    subtitle:['（证书更新）'],
                    certification:{
                        name: 'CMA',
                        src: [require('@/assets/images/chemicalHistory/2022.06.jpg')]
                    }
                },
            ],
            tableData1:[
                {
                    field: '物理化学性质试验项目',
                    project: '图谱（红外、紫外、质谱、核磁）',
                    period: '1',
                    secondField: '',
                    index: 1
                },
                {
                    field: '物理化学性质试验项目',
                    project: '熔点',
                    period: '1',
                    secondField: '',
                    index: 2
                },
                {
                    field: '物理化学性质试验项目',
                    project: '沸点',
                    period: '1',
                    secondField: '',
                    index: 3
                },
                {
                    field: '物理化学性质试验项目',
                    project: '蒸气压',
                    period: '2',
                    secondField: '',
                    index: 4
                },
                {
                    field: '物理化学性质试验项目',
                    project: '水溶解度',
                    period: '3',
                    secondField: '',
                    index: 5
                },
                {
                    field: '物理化学性质试验项目',
                    project: '分配系数(正辛醇/水)',
                    period: '3',
                    secondField: '',
                    index: 6
                },
                {
                    field: '物理化学性质试验项目',
                    project: '液体和固体的密度',
                    period: '1',
                    secondField: '',
                    index: 7
                },
                {
                    field: '物理化学性质试验项目',
                    project: '与pH值有关的水解作用',
                    period: '4',
                    secondField: '',
                    index: 8
                },
                {
                    field: '物理化学性质试验项目',
                    project: '在水中的离解常数',
                    period: '2',
                    secondField: '',
                    index: 9
                },
                {
                    field: '物理化学性质试验项目',
                    project: '水溶液的表面张力',
                    period: '1',
                    secondField: '',
                    index: 10
                },
                {
                    field: '物理化学性质试验项目',
                    project: 'pH值和酸碱度',
                    period: '1',
                    secondField: '',
                    index: 11
                },
                {
                    field: '物理化学性质试验项目',
                    project: '粒径',
                    period: '1',
                    secondField: '',
                    index: 12
                },
                {
                    field: '物理化学性质试验项目',
                    project: '冰点',
                    period: '2',
                    secondField: '',
                    index: 13
                },
                {
                    field: '物理化学性质试验项目',
                    project: '比旋光度',
                    period: '1',
                    secondField: '',
                    index: 14
                },
                {
                    field: '物理化学性质试验项目',
                    project: '亨利常数',
                    period: '1',
                    secondField: '',
                    index: 15
                },
                {
                    field: '物理化学性质试验项目',
                    project: '环境中的检出方法及描述',
                    period: '3',
                    secondField: '',
                    index: 16
                },
                {
                    field: '物理化学性质试验项目',
                    project: '聚合物在水中和有机溶剂中的溶解性',
                    period: '3',
                    secondField: '',
                    index: 17
                },
                {
                    field: '物理化学性质试验项目',
                    project: '聚合物在酸碱条件下的稳定性',
                    period: '3',
                    secondField: '',
                    index: 18
                },
                {
                    field: '非测试数据服务',
                    project: '新化学物质查新',
                    period: '/',
                    secondField: '',
                    index: 19
                },
                {
                    field: '非测试数据服务',
                    project: '新化学物质环境风险评估报告',
                    period: '/',
                    secondField: '',
                    index: 20
                },
                {
                    field: '非测试数据服务',
                    project: 'QSAR预测报告',
                    period: '/',
                    secondField: '',
                    index: 21
                },
                {
                    field: '非测试数据服务',
                    project: '新化学物质备案',
                    period: '/',
                    secondField: '',
                    index: 22
                },
                {
                    field: '非测试数据服务',
                    project: '新化学物质简易登记',
                    period: '/',
                    secondField: '',
                    index: 23
                },
                {
                    field: '非测试数据服务',
                    project: '新化学物质常规登记',
                    period: '/',
                    secondField: '',
                    index: 24
                },
                {
                    field: '非测试数据服务',
                    project: '中国现有化学物质名录增补申请',
                    period: '/',
                    secondField: '',
                    index: 25
                },
            ],
            tableData2:[
                {
                    field: '生态毒理学试验项目',
                    project: '吸附/解吸附性',
                    period: '6',
                    secondField: '',
                    index: 26
                },
                {
                    field: '生态毒理学试验项目',
                    project: '藻类生长抑制毒性',
                    period: '3',
                    secondField: '',
                    index: 27
                },
                {
                    field: '生态毒理学试验项目',
                    project: '溞类急性毒性',
                    period: '3',
                    secondField: '',
                    index: 28
                },
                {
                    field: '生态毒理学试验项目',
                    project: '鱼类急性毒性',
                    period: '3',
                    secondField: '',
                    index: 29
                },
                {
                    field: '生态毒理学试验项目',
                    project: '蚯蚓急性毒性',
                    period: '3',
                    secondField: '',
                    index: 30
                },
                {
                    field: '生态毒理学试验项目',
                    project: '活性污泥呼吸抑制毒性',
                    period: '3',
                    secondField: '',
                    index: 31
                },
                {
                    field: '生态毒理学试验项目',
                    project: '大型溞繁殖',
                    period: '5',
                    secondField: '',
                    index: 32
                },
                {
                    field: '生态毒理学试验项目',
                    project: '鱼类幼体生长',
                    period: '6',
                    secondField: '',
                    index: 33
                },
                {
                    field: '生态毒理学试验项目',
                    project: '种子发芽和根伸长的毒性',
                    period: '4',
                    secondField: '',
                    index: 34
                },
                {
                    field: '生态毒理学试验项目',
                    project: '快速生物降解性',
                    period: '4',
                    secondField: '',
                    index: 35
                },
                {
                    field: '生态毒理学试验项目',
                    project: '固有生物降解性',
                    period: '4',
                    secondField: '',
                    index: 36
                },
                {
                    field: '生态毒理学试验项目',
                    project: '生物累积性',
                    period: '6',
                    secondField: '',
                    index: 37
                },
                {
                    field: '健康毒理学试验项目',
                    project: '急性经口毒性',
                    period: '3',
                    secondField: '',
                    index: 38
                },
                {
                    field: '健康毒理学试验项目',
                    project: '急性经皮毒性',
                    period: '3',
                    secondField: '',
                    index: 39
                },
                {
                    field: '健康毒理学试验项目',
                    project: '急性吸入毒性',
                    period: '3',
                    secondField: '',
                    index: 40
                },
                {
                    field: '健康毒理学试验项目',
                    project: '皮肤腐蚀/刺激',
                    period: '3',
                    secondField: '',
                    index: 41
                },
                {
                    field: '健康毒理学试验项目',
                    project: '眼刺激',
                    period: '3',
                    secondField: '',
                    index: 42
                },
                {
                    field: '健康毒理学试验项目',
                    project: '皮肤致敏',
                    period: '3',
                    secondField: '',
                    index: 43
                },
                {
                    field: '健康毒理学试验项目',
                    project: '细菌回复突变',
                    period: '3',
                    secondField: '',
                    index: 44
                },
                {
                    field: '健康毒理学试验项目',
                    project: '体外哺乳动物细胞染色体畸变',
                    period: '3',
                    secondField: '',
                    index: 45
                },
                {
                    field: '健康毒理学试验项目',
                    project: '哺乳动物红细胞微核',
                    period: '3',
                    secondField: '',
                    index: 46
                },
                {
                    field: '健康毒理学试验项目',
                    project: '哺乳动物骨髓染色体畸变',
                    period: '3',
                    secondField: '',
                    index: 47
                },
                {
                    field: '健康毒理学试验项目',
                    project: '体外哺乳动物细胞基因突变',
                    period: '3',
                    secondField: '',
                    index: 48
                },
                {
                    field: '健康毒理学试验项目',
                    project: '彗星试验',
                    period: '3',
                    secondField: '',
                    index: 49
                },
                {
                    field: '健康毒理学试验项目',
                    project: '重复染毒28天经口毒性',
                    period: '4',
                    secondField: '',
                    index: 50
                },
                {
                    field: '健康毒理学试验项目',
                    project: '反复经皮毒性（21/28天）',
                    period: '5',
                    secondField: '',
                    index: 51
                },
                {
                    field: '健康毒理学试验项目',
                    project: '亚急性吸入毒性（28天）',
                    period: '4',
                    secondField: '',
                    index: 52
                },
                {
                    field: '健康毒理学试验项目',
                    project: '亚慢性（90天）经口毒性',
                    period: '6',
                    secondField: '',
                    index: 53
                },
                {
                    field: '健康毒理学试验项目',
                    project: '亚慢性（90天）经皮毒性',
                    period: '6',
                    secondField: '',
                    index: 54
                },
                {
                    field: '健康毒理学试验项目',
                    project: '亚慢性（90天）吸入毒性',
                    period: '6',
                    secondField: '',
                    index: 55
                },
                {
                    field: '健康毒理学试验项目',
                    project: '孕期发育毒性（致畸）',
                    period: '6',
                    secondField: '',
                    index: 56
                },
            ],
      }
    },
    methods: {},
  }
  </script> 
  
  <style lang='less' scoped>
    .bottom{
        margin-top: 80px;
    }
  </style>
  